import { v4 } from 'uuid';

import classes from './Toggle.module.css';

type Props = {
    id?: string;
    toggled?: boolean;
    className?: string;
    disabled?: boolean;
    size?: 'L';
};

const Toggle = ({ id = v4(), toggled, className, disabled = false, size }: Props) => (
    <div
        id={id}
        className={`${classes.toggle} ${toggled ? classes.toggled : ''} ${size ? classes[size] : ''} ${className} ${
            disabled ? classes.disabled : ''
        }`}
    >
        <div className={classes.toggleIndicator} />
    </div>
);

Toggle.defaultProps = {
    className: '',
};

export default Toggle;
